<template>
	<div class="auth-container">
        <auth-header />
        
	    <main id="content" role="main" class="main pt-0">
	      	<!-- Content -->
	      	<div class="container-fluid px-3">
		        <div class="row">
		          	<div class="auth-cover-layout col-lg-4 d-none d-lg-flex min-vh-lg-100 position-relative">
			            <div class="auth-logo position-absolute top-0 left-0 right-0">
			              	<div class="d-none d-lg-flex justify-content-between">
				                <a href="/">
				                  	<img src="/images/cashouse_logo_mobile.png" alt="Image Description">
				                </a>
			              	</div>
			            </div>

			            <div class="auth-cover-content">
			            	<h1>Bentornato su Cashouse!</h1>
			            </div>

			            <img src="/images/property_bg.svg" class="auth-bg-cover-img img-fluid">
		          	</div>

		          	<div class="auth-content col-lg-8 justify-content-center align-items-center min-vh-lg-100">
		          		<slot name="back-button" />

		          		<h1 class="d-block d-lg-none text-primary">Bentornato su Cashouse!</h1>

			            <div class="w-100 pt-10 pt-lg-7 pb-7">
			            	<slot />	
			            </div>
		          	</div>
		        </div>
	      	</div>
	      	<!-- End Content -->
	    </main>
	</div>
</template>

<script>
	import AuthHeader from '@/Layouts/Partials/AuthHeader'

	export default {
		components: {
			AuthHeader
		}
	}
</script>